import swal from "sweetalert2";
import { __ } from "services/Translator";
import { getInitialSettings } from "utils/initialSettings";
import { getPostSignupConfig, isImmediateLogin } from "utils/signupFlow";
import "components/loginReg/postSignupPopup.css";

/**
 * Shared post-signup behaviour for every signup-success entry point (the login
 * modal and the PWA inline onboarding auth), so the admin-configured pop-up and
 * login-timing are applied consistently and there is no second, divergent path.
 */

const escapeHtml = (s) =>
  String(s == null ? "" : s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
  );

/** Fetch the initial-settings payload (signup_flow config), or null on failure. */
export async function fetchInitialSettings() {
  return getInitialSettings();
}

/** Show the admin-configured GCC-branded post-signup confirmation pop-up. */
export async function showPostSignupPopup(settings) {
  const cfg = getPostSignupConfig(settings);
  const linesHtml = cfg.lines
    .map((l) => `<p class="gcc-ps-line">${escapeHtml(__(l))}</p>`)
    .join("");

  const opts = {
    customClass: {
      popup: "gcc-postsignup-popup",
      title: "gcc-ps-title",
      htmlContainer: "gcc-ps-lines",
      confirmButton: "gcc-ps-btn",
    },
    buttonsStyling: false,
    title: __(cfg.title),
    html: linesHtml,
    icon: "success",
    confirmButtonText: __(cfg.button_text),
    allowOutsideClick: true,
  };
  if (cfg.background_image_url) {
    opts.background = `linear-gradient(rgba(6,26,17,.80), rgba(6,26,17,.88)), url("${cfg.background_image_url}") center / cover no-repeat`;
  } else if (/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(cfg.background_color)) {
    opts.background = cfg.background_color;
  }

  await swal.fire(opts);
}

/** Whether the caller should immediately log the new player in (login_timing). */
export function shouldImmediatelyLogin(settings) {
  return isImmediateLogin(settings);
}
